// 原 APP 籌碼結算動畫的純時序。
// 對應 PlayerResultMoneyEntity.getRunDuration() 與 GameResultMoneyScene.RUN_DELAY。

export const MONEY_RUN_DELAY_MS = 2500; // 進場後等待 2.5 秒才開始跑分
export const MONEY_RUN_MIN_DURATION_MS = 1000; // 小額輸贏最短跑 1 秒
export const MONEY_RUN_MAX_DURATION_MS = 5000; // 大額輸贏最長跑 5 秒
const MONEY_RUN_MAX_VALUE = 100_000; // 達此金額即使用最長時數
const MONEY_RUN_DURATION_VALUE_RANGE = 99_000; // 原 APP 線性換算分母

/** 依本局輸贏絕對值計算跑分時間；公式忠實對照原 APP。 */
export const getMoneyRunDurationMs = (value: number): number => {
  const absolute = Math.abs(value);
  if (absolute >= MONEY_RUN_MAX_VALUE) return MONEY_RUN_MAX_DURATION_MS;
  if (absolute <= 1000) return MONEY_RUN_MIN_DURATION_MS;
  return (
    MONEY_RUN_MIN_DURATION_MS +
    (MONEY_RUN_MAX_DURATION_MS - MONEY_RUN_MIN_DURATION_MS) *
      (absolute / MONEY_RUN_DURATION_VALUE_RANGE)
  );
};
